import React from "react";
import { ErrorMessage, Field } from 'formik';
import { Row, Col, Button } from "reactstrap";

const Contact = ({ component, remove, fieldNamePrefix = "", setDefaultContact, contactType = 'building' }) => {
    const labelStyle = { color: "#334155", fontSize: 14 };
    const reportCellStyle = { width: 48, textAlign: "center", padding: "4px 0" };
    const reportTitleStyle = { textAlign: "left", fontWeight: "normal", padding: "4px 0" };
    const emailNotifications = (
        <>
            <Col xs={12} md={contactType == "elevatorCompany" ? 4 : 3}>
                <label style={{ ...labelStyle, fontSize: contactType == "elevatorCompany" ? 13 : 14 }}>
                    <Field type="checkbox" name={`${fieldNamePrefix}sendAlerts`} />
                    {" Send email alerts when elevator is not working"}
                </label>
            </Col>
            <Col xs={12} md={contactType == "elevatorCompany" ? 4 : 3}>
                <label style={{ ...labelStyle, fontSize: contactType == "elevatorCompany" ? 13 : 14 }}>
                    <Field type="checkbox" name={`${fieldNamePrefix}notifyWhen911Called`} />
                    {" Notify by email when 911 called"}
                </label>
            </Col>
        </>
    );

    return (
        <>
            <Row className="mt-4">
                <Col >
                    <Field type="text" name={`${fieldNamePrefix}contactName`} label="Contact" component={component} />
                    <ErrorMessage name={`${fieldNamePrefix}contactName`} component="div" className="invalid-feedback" style={{ display: "block" }} />
                </Col> 

                <Col >
                    <Field type="email" name={`${fieldNamePrefix}email`} label="Email Address" component={component} />
                    <ErrorMessage name={`${fieldNamePrefix}email`} component="div" className="invalid-feedback" style={{ display: "block" }} />
                </Col>

                <Col >
                    <Field type="text" name={`${fieldNamePrefix}phone`} label="Phone Number" component={component} />
                    <ErrorMessage name={`${fieldNamePrefix}phone`} component="div" className="invalid-feedback" style={{ display: "block" }} />
                </Col>
                <Col md="1">
                    <Field type="text" name={`${fieldNamePrefix}phoneExtension`} label="Ext." component={component} />
                    <ErrorMessage name={`${fieldNamePrefix}phoneExtension`} component="div" className="invalid-feedback" style={{ display: "block" }} />
                </Col>
                <Col md="3">
                    <Field type="textarea" name={`${fieldNamePrefix}phoneNotes`} label="Notes (Hours of Availability)" component={component} style={{
                        height: "36px",
                        maxHeight: "40px",
                        overflowY: "auto",
                        resize: "none",
                        lineHeight: "1.5",
                        borderRadius: "30px",
                        border: "1px solid #e3e3e3",

                    }} />
                    <ErrorMessage name={`${fieldNamePrefix}phoneNotes`} component="div" className="invalid-feedback" style={{ display: "block" }} />
                </Col>


            </Row>
            <div style={{ marginLeft: 24, color: "#334155", fontSize: 14 }}>
                <Row className="mt-3">
                    <Col md="2">
                        <label style={labelStyle}>
                            <Field type="checkbox" name={`${fieldNamePrefix}defaultContact`}
                            onChange={(e) => {
                                setDefaultContact(e.target.checked)
                            }}
                        />
                            {" Default contact"}
                    </label>
                </Col>
                    <Col md="3">
                        <label style={labelStyle}>
                            <Field type="checkbox" name={`${fieldNamePrefix}availableForEmergencyCalls`} />
                            {" Available to answer emergency calls"}
                    </label>
                    </Col>                    

                    {contactType == "elevatorCompany" &&
                        <Col md="3">
                            <label style={labelStyle}>
                                <Field type="checkbox" name={`${fieldNamePrefix}callCenterMonitoringContact`} />
                                {" Call center monitoring contact"}
                            </label>
                        </Col>
                    }
                    {contactType == "elevatorCompany" &&
                        <Col md="4">
                            <label style={{ ...labelStyle, color: "#9a9a9a" }}>
                                <Field type="checkbox" name={`${fieldNamePrefix}loggedOnToReceiveSMS`} disabled />
                                {" Logged on to receive SMS "}
                                <span style={{ fontSize: 11, fontStyle: 'italic', marginLeft: 2 }}>(set via text message)</span>
                            </label>
                        </Col>
                    }

                    {contactType != "elevatorCompany" && emailNotifications}
                </Row>
                {contactType == "elevatorCompany" &&
                    <div style={{ marginTop: 8, padding: "12px 14px", background: "#f8fafc", border: "1px solid #e3e8ee", borderRadius: 6, fontSize: 13 }}>
                        <div style={{ display: "flex", flexWrap: "wrap", gap: "16px 24px" }}>
                            <section style={{ flex: "0 1 350px", minWidth: 0, width: "100%" }}>
                                <table style={{ width: "100%", borderCollapse: "collapse" }}>
                                    <thead style={{ borderBottom: "1px solid #e3e8ee" }}>
                                        <tr>
                                            <th scope="col" style={{ ...reportTitleStyle, fontWeight: "bold" }}>Send Report Notifications for</th>
                                            <th scope="col" style={reportCellStyle}>SMS</th>
                                            <th scope="col" style={reportCellStyle}>Email</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {[
                                            { label: "All completed calls", sms: "smsSummaryCallReport", email: "emailSummaryCallReport" },
                                            { label: "Emergencies needing help", sms: "smsWhenHelpNeeded", email: "emailWhenHelpNeeded" },
                                            { label: "Customer service requests", sms: "smsForCustomerServiceReport", email: "emailForCustomerServiceReport" }
                                        ].map(report => (
                                            <tr key={report.sms}>
                                                <th scope="row" style={reportTitleStyle}>{report.label}</th>
                                                <td style={reportCellStyle}>
                                                    <Field type="checkbox" name={`${fieldNamePrefix}${report.sms}`} aria-label={`SMS reports: ${report.label}`} />
                                                </td>
                                                <td style={reportCellStyle}>
                                                    <Field type="checkbox" name={`${fieldNamePrefix}${report.email}`} aria-label={`Email reports: ${report.label}`} />
                                                </td>
                                            </tr>
                                        ))}
                                    </tbody>
                                </table>
                            </section>

                            <div style={{ flex: "1 1 300px", minWidth: 0 }}>
                                <h3 style={{ margin: "0 0 8px", color: "#253347", fontSize: 13, fontWeight: 600, lineHeight: 1.4 }}>Other notifications</h3>
                                <Row>
                                    {emailNotifications}
                                </Row>
                                <Row>
                                    <Col xs={12} md={4}>
                                        <label style={{ ...labelStyle, fontSize: 13 }}>
                                            <Field type="checkbox" name={`${fieldNamePrefix}smsWhenContactStatusChanges`} />
                                            {" SMS when a contact logs in or out"}
                                        </label>
                                    </Col>
                                    <Col xs={12} md={4}>
                                        <label style={{ ...labelStyle, fontSize: 13 }}>
                                            <Field type="checkbox" name={`${fieldNamePrefix}smsWhenNoAvailableContacts`} />
                                            {" SMS when no contacts are available"}
                                        </label>
                                    </Col>
                                </Row>
                            </div>
                        </div>
                    </div>
            }
            </div>

            {remove &&
                <Col className="mt-3" style={{ marginLeft: 24 }}>
                    <Button type="button" color="primary" outline size="sm" onClick={remove} style={{ margin: 0, padding: "4px 10px", fontSize: 12, lineHeight: 1.4 }}>Remove This Contact</Button>
                </Col>
            }

        </>
    );
}

export default Contact